import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { BlogCustomModelPopup } from './BlogCustomModelPopup';

export const BLOG_CUSTOM_MODEL_POPUP = Symbol('BLOG_CUSTOM_MODEL');

export const useBlogCustomModelPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(BLOG_CUSTOM_MODEL_POPUP, BlogCustomModelPopup);
  });

  return useCallback(
    ({ brandVoiceId, onConnectSuccess, blogCustomModel }) => {
      return new Promise((resolve) => {
        popups.openPopup(BLOG_CUSTOM_MODEL_POPUP, {
          onSubmit: (result) => {
            popups.closePopup(BLOG_CUSTOM_MODEL_POPUP);
            resolve(result);
          },
          onClose: () => {
            popups.closePopup(BLOG_CUSTOM_MODEL_POPUP);
            resolve();
          },
          brandVoiceId,
          onConnectSuccess,
          blogCustomModel,
        });
      });
    },
    [popups]
  );
};
